module.exports = __webpack_public_path__ + "img/renkou.24e65f93.jpg";